import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import { BiData } from '@wix/da-bi/pkg/events';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
class FaveButton extends React.Component {
    render() {
        const { deviation, isFavourite, faveCount, isLoading, className, 'aria-label': ariaLabel } = this.props;
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "FaveButton"
        }, /*#__PURE__*/ React.createElement(BiButton, {
            "data-hook": BiDataHook.FAVE_BUTTON,
            disabled: isLoading,
            onClick: this.onFaveToggle,
            className: className,
            "aria-label": ariaLabel,
            biData: BiData({
                evid: isFavourite ? 109 : 102,
                creatorid: deviation.author ? deviation.author.useridUuid : undefined,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId
            })
        }, this.props.children({
            isFavourite,
            faveCount
        })));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onFaveToggle", ()=>{
            const { deviation, onChangeFave, isFavourite, notificationQueue = 'default' } = this.props;
            onChangeFave && onChangeFave(deviation, !isFavourite, notificationQueue);
        });
    }
}
export default FaveButton;
